import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Checkbox from "@mui/material/Checkbox";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import Tooltip from "@mui/material/Tooltip";

function ClaimsTableData({ data, selectedIds, onToggle, onEdit, onDelete, onReverse }) {
  const columns = [
    { Header: "", accessor: "checkbox", align: "center", width: "5%" },
    { Header: "Created At", accessor: "createdAt", align: "left" },
    { Header: "Rec No.", accessor: "receiptNo", align: "left" },
    { Header: "Policy No", accessor: "policyNumber", align: "left" },
    { Header: "Card No", accessor: "cardNumber", align: "left" },
    { Header: "Plan", accessor: "plan", align: "left" },
    { Header: "Hospital", accessor: "hospitalName", align: "left" },
    { Header: "Amount by Ins", accessor: "amountByInsurance", align: "right" },
    { Header: "Co-Pay", accessor: "amountPayableByBeneficiary", align: "right" },
    { Header: "Total Amount", accessor: "totalAmount", align: "right" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case "APPROVED":
      case "SUCCESS":
        return "success";
      case "PENDING":
        return "info";
      case "Reversed":
        return "error";
      default:
        return "secondary";
    }
  };

  const rows = (data || []).map((item) => ({
    checkbox: (
      <Checkbox
        size="small"
        checked={selectedIds.includes(item.id)}
        onChange={() => onToggle(item.id)}
      />
    ),
    createdAt: (
      <MDTypography variant="caption">{item.createdAt?.replace("T", " ") || ""}</MDTypography>
    ),
    receiptNo: <MDTypography variant="caption">{item.receiptNo || "N/A"}</MDTypography>,
    policyNumber: (
      <MDTypography variant="caption" color="text">
        {item.policyNumber}
      </MDTypography>
    ),
    cardNumber: (
      <MDTypography variant="caption" color="text">
        {item.cardNumber}
      </MDTypography>
    ),
    plan: (
      <MDTypography variant="caption" color="text">
        {item.plan}
      </MDTypography>
    ),
    hospitalName: (
      <MDTypography variant="caption" color="text">
        {item.hospitalName}
      </MDTypography>
    ),
    amountByInsurance: (
      <MDTypography variant="caption" color="text">
        {item.amountByInsurance?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </MDTypography>
    ),
    amountPayableByBeneficiary: (
      <MDTypography variant="caption" color="text">
        {item.amountPayableByBeneficiary?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </MDTypography>
    ),
    totalAmount: (
      <MDTypography variant="caption" color="text">
        {item.totalAmount?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </MDTypography>
    ),
    status: (
      <MDBadge badgeContent={item.status} size="xs" color={getStatusColor(item.status)} container />
    ),
    action: (
      <div>
        <Tooltip title="Edit" arrow>
          <IconButton size="small" onClick={() => onEdit(item)}>
            <Icon>edit</Icon>
          </IconButton>
        </Tooltip>
        <Tooltip title="Reverse" arrow>
          <IconButton size="small" onClick={() => onReverse(item)}>
            <ChangeCircleIcon fontSize="small" color="error" />
          </IconButton>
        </Tooltip>
        {/*
        <IconButton size="small" color="error" onClick={() => onDelete(item)}>
          <Icon>delete</Icon>
        </IconButton>
        */}
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted={false}
      entriesPerPage={{ defaultValue: 50, entries: [50, 100, 500] }}
      showTotalEntries={false}
      noEndBorder
      size="small"
    />
  );
}

ClaimsTableData.propTypes = {
  data: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onReverse: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ClaimsTableData;
